import React from 'react'
import classNames from 'classnames'
import {BannerNotificationProps} from '@/components/composite/notifications/BannerNotification/props'
import {CheckOutlined, CloseOutlined, InfoCircleOutlined, WarningOutlined} from '@ant-design/icons'
import {notificationDescription} from '@/utils'
import styles from './styles.scss'

export const BannerNotification: React.FC<BannerNotificationProps> = ({notification, onCloseNotification}) => {
    const {id, notificationLevelId, title, isClosable, description} = notification

    const renderNotificationIcon = (notificationLevel) => {
        switch (notificationLevel) {
            case 'info':
                return <InfoCircleOutlined className={styles.icon}/>
            case 'success':
                return <CheckOutlined className={styles.icon}/>
            case 'warning':
                return <WarningOutlined className={styles.icon}/>
            case 'error':
                return <CloseOutlined className={styles.icon}/>
            default:
                return null
        }
    }

    return (
        <div className={classNames(styles.notificationContainer, styles[notificationLevelId])}>
            <div className={styles.iconContainer}>
                {renderNotificationIcon(notificationLevelId)}
            </div>
            <div>
                <div>
                    <span className={styles.title}>{title}</span>
                </div>
                <div className={styles.description} dangerouslySetInnerHTML={{ __html: notificationDescription(description) }} />
            </div>

            {
                isClosable &&
                <div
                    onClick={() => onCloseNotification(id)}
                    className={classNames(styles.closeButton, styles[notificationLevelId])}
                />
            }
        </div>
    )
}
